import {logger} from 'common'
import {GraphQLClient} from 'graphql-request'
import {IncomingMessage} from 'http'
import {signOut} from 'next-auth/react'

import {graphQLClientSessionManager} from './clientGqlSessionManager'
import {getSdk} from './graphqlSdk'

export const getClientGQL = async (ctx?: {req: IncomingMessage}, useAdminToken?: boolean) => {
  // for admins, the access token is with role admin, so this says that unless useAdminToken is true
  // the graphql will be for everyone called with role user
  const token = await graphQLClientSessionManager.getToken(ctx, useAdminToken)
  if (!token) {
    // Raw user-agent rather than a parsed one: ua-parser-js is 23 KB for one error log.
    logger.error(
      {ua: typeof navigator === 'undefined' ? undefined : navigator.userAgent},
      `Client: GQL client got session error`,
    )
    await signOut()
  }

  return getSdk(
    new GraphQLClient(process.env.gqlEndpoint, {
      headers: token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : {},
    }),
  )
}

export const getAnonymousClient = () => {
  return getSdk(new GraphQLClient(process.env.gqlEndpoint, {headers: {}}))
}
